export const logo = require('./../images/logo.png')
export const brandmark = require('./../images/brandmark.png')
export const navIcon = require('./../images/navIcon.svg')

export const misc = {}
